module.exports = __webpack_public_path__ + "img/flag_cn.2aa40960.svg";